<template>
  <div>
    <router-link class="nav-link cx_global_menu_item" :to="to" :class="{ active: isActive(selector) }" v-if="$api.perms.hasMenuPermission(perm)">
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i><SvgIcon :name="svg" v-if="svg" :width="24" :height="24"/>{{ $translate(caption) }}
    </router-link>
    <b-nav-item class="cx_global_menu_item" v-if="$api.perms.hasMenuPermission(perm) == false" disabled>
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i><SvgIcon :name="svg" v-if="svg" :width="24" :height="24"/>{{ $translate(caption) }}
    </b-nav-item>
    <b-nav-item   class="nav-item  cx_global_menu_item" v-if="to == null" @click="onClick">
      <i v-if="icon != null" class="material-icons md valign">{{ icon }}</i>{{ $translate(caption) }}
    </b-nav-item>        
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/agiles/common';

@Component
export default class GlobalMenuItem extends Vue {
  @Prop() public to!: string;
  @Prop() public caption!: string;
  @Prop() public selector!: string;
  @Prop() public icon?: string;
  @Prop({ default: null }) public svg: string;      
  @Prop({ default: null }) public perm: string;

  public isActive(path: string) {
    if (path === '/') {
      return this.$route.path === path;
    } else {
      return this.$route.path.startsWith(path);
    }
  }
  public onClick(){
      this.$emit("click");
  }  
}
</script>

<style lang="scss">

  .cx_global_menu_item{
    min-width: 120px;
    white-space: nowrap;
    // .nav-link{
    //   padding-top:4px;
    //   padding-bottom:4px;
    // }
    &.nav-link{
      color: #DBE6FF !important;
      &:hover {
        color: white;
        background-color: #6fb5ff60 ;        
      }
      &.active {
        color: white;
        background-color: #6fb5ff45 ;        
      }      
    }
    &.nav-item{
      a{
        color: #DBE6FF !important;
      }

      padding: 0px 5px;
      height: 40.11px;
      &:hover {
        color: white;
        background-color: #6fb5ff60 ;        
      }
      &.active {
        color: white;
        background-color: #6fb5ff45 ;        
      }      
    }    

    &.active {
      color: white;
    }         
}
.cx_global_menu{
  .nav-link{
    &.dropdown-toggle{
        color: #DBE6FF !important;    
        &:hover{
          color: white;
          background-color: #6fb5ff60 ;        
        }      
    }
  }
}


</style>
